import check from './icons/check.svg';
import houseSearch from './icons/house_search.svg';
import form from './icons/form.svg';
import money from './icons/money.svg';

export const content = [
  {
    iconSrc: check,
    title: 'Большая база риелторов',
    text: 'С Циан работают более 100 000 риелторов из разных регионов России.',
  },
  {
    iconSrc: houseSearch,
    title: 'Индивидуальный подбор',
    text: 'Учтём все детали от военной ипотеки до материнского капитала.',
  },
  {
    iconSrc: form,
    title: 'Простая анкета',
    text: 'Уточним только самую необходимую информацию.',
  },
  {
    iconSrc: money,
    title: 'Бесплатный сервис',
    text: 'Подбор бесплатный. Условия работы обсуждаются с риелтором напрямую.',
  },
];
